import { Link } from "@seneca/senekit";

import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import { ROUTES } from "routing/routes";

import CheckYourEmail from "./CheckYourEmail";
import { PARENT_PRECONNECTED_SIGN_IN_CALLBACK_URL } from "./consts";

export default function ParentCheckYourEmail() {
  const { email, givenName, familyName } = useTypedState(
    ROUTES.SIGN_UP_PARENT.CHECK_YOUR_EMAIL
  );

  const linkToPasswordForm = ROUTES.SIGN_UP_PARENT.buildPath(
    {},
    { showPasswordSignUp: true }
  );

  return (
    <CheckYourEmail
      email={email}
      metadata={{ givenName, familyName }}
      callbackUrl={PARENT_PRECONNECTED_SIGN_IN_CALLBACK_URL}
    >
      {{
        alternativeLoginLink: (
          <Link to={linkToPasswordForm} size="small">
            Use password instead
          </Link>
        )
      }}
    </CheckYourEmail>
  );
}
